import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { selector } from "../api";

export const Navbar = () => {
  const user = selector.User();

  let navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const toggleChecked = () => setChecked((value) => !value);

  const handleLogout = () => {
    localStorage.removeItem("persist:root");
    navigate("/");
    document.location.reload();
  };

  return (
    <>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <a href="index.html" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src="assets/images/logo/smz.png" alt="SMZ" height="28" />
                  </span>
                  <span className="logo-lg">
                    <img src="assets/images/logo/smz.png" alt="SMZ" height="30" />
                  </span>
                </a>

                <a href="index.html" className="logo logo-light">
                  <span className="logo-sm">
                    <img src="assets/images/logo/smz.png" alt="SMZ" height="28" />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="assets/images/logo/smz.png"
                      alt="SMZ"
                      height="30"
                    />
                  </span>
                </a>
              </div>

              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">
              <div className="dropdown d-md-none topbar-head-dropdown header-item">
                <button
                  type="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                  id="page-header-search-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="bx bx-search fs-22"></i>
                </button>
                <div
                  className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="dropdown ms-1 topbar-head-dropdown header-item">
                <button
                  type="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span>Eng</span>
                </button>
              </div>

              <div className="ms-1 header-item d-none d-sm-flex">
                <button
                  type="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                  data-toggle="fullscreen"
                >
                  <i className="bx bx-fullscreen fs-22"></i>
                </button>
              </div>

              <div className="ms-1 header-item d-none d-sm-flex">
                <button
                  type="button"
                  onClick={toggleChecked}
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
                >
                  <i className="bx bx-moon fs-22"></i>
                </button>
                <input
                  className="form-check-input"
                  hidden
                  type="radio"
                  name="data-layout-mode"
                  id="layout-mode-dark"
                  value={checked ? "dark" : "light"}
                />
              </div>

              <div className="dropdown ms-sm-3 header-item ">
                <button
                  type="button"
                  className="btn"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src="assets/images/users/user-dummy-img.jpg"
                      alt="Header Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {user.username}
                      </span>
                    </span>
                  </span>
                </button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">
                    Welcome{" "}
                    <span>
                      {user.first_name ? user.first_name : user.username} &emsp;{" "}
                      {user.last_name && user.last_name}
                    </span>
                  </h6>
                  <Link className="dropdown-item" to={"/profile"}>
                    <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle">Profile</span>
                  </Link>

                  <Link className="dropdown-item" to={"/password"}>
                    <i className="mdi mdi-lock-outline text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle">Password</span>
                  </Link>

                  <Link
                    className="dropdown-item"
                    to={"#"}
                    onClick={handleLogout}
                  >
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
